import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

class ImageFadeIns {
    constructor() {
        // Check for Zoom Images
        const zoomImage = document.querySelector('.js-zoom-image');
        if (zoomImage) {
            this.zoomInit();
        }

        // Check for Slide Images
        const slideImage = document.querySelector('.js-slide-image');

        if (slideImage) {
            this.slideInit();
        }
    }

    zoomInit() {
        const run = () => {
            // console.log("hello Principles Elements")
            const zoomImages = document.querySelectorAll('.js-zoom-image');


            zoomImages.forEach(function (item) {
                const baseDelay = parseFloat((item.dataset.delay || '0').replace(',', '.')) || 0;
                const baseDuration = parseFloat((item.dataset.duration || '1.4').replace(',', '.')) || 1.4;
                const credits = item.nextElementSibling?.matches('.credits')
                    ? item.nextElementSibling
                    : null;

                let tl = gsap
                    .timeline({
                        delay: baseDelay,
                        scrollTrigger: {
                            trigger: item,
                            start: 'top 90%',
                            markers: false,
                            toggleActions: 'play none none none'
                        }
                    })
                    .from(item.querySelectorAll('img, video'), {
                        scale: 1.1,
                        opacity: 0,
                        duration: baseDuration,
                        ease: 'power2.out'
                    })

                if (credits) {
                    tl.from(credits, {
                        opacity: 0,
                        duration: .5,
                        ease: 'power2.out'
                    }, "-=0.2");
                }
            });
        };
        if (document.readyState !== 'loading') run();
        else document.addEventListener('DOMContentLoaded', run);
    }

    slideInit() {
        const run = () => {
            const slideImages = document.querySelectorAll('.js-slide-image');

            slideImages.forEach(function (item) {
                let tl = gsap
                    .timeline({
                        scrollTrigger: {
                            trigger: item,
                            start: 'top 90%',
                            markers: false,
                            toggleActions: 'play none none none'
                        }
                    })
                    .from(item, {
                        x: 400,
                        opacity: 0,
                        duration: 1.2,
                        ease: 'power2.out'
                    })
                    .from(
                        item.querySelector('img'),
                        {
                            x: -400,
                            // opacity: 0,
                            duration: 1.2,
                            ease: 'power2.out'
                        },
                        0
                    );
            });
        };
        if (document.readyState !== 'loading') run();
        else document.addEventListener('DOMContentLoaded', run);
    }
}

export default ImageFadeIns;
